export enum DraftTypes {
    WEIGHTS_AND_THRESHOLDS = 'QUESTION_WEIGHTS_AND_THRESHOLDS',
    QUESTION_ASSIGNMENTS = 'QUESTION_ASSIGNMENTS',
    QUESTION_ANSWER_KEYS = 'QUESTION_ANSWER_KEYS',
}

export enum GradingWorkflowSettingsTypeKeys {
    WEIGHTS_AND_THRESHOLDS = 'weightsAndThresholds',
    QUESTION_ASSIGNMENTS = 'questionAssignments',
    QUESTION_ANSWER_KEYS = 'questionAnswerKeys',
}

export type GradingWorkflowSettingsType = GradingWorkflowSettingsTypeKeys.WEIGHTS_AND_THRESHOLDS
    | GradingWorkflowSettingsTypeKeys.QUESTION_ASSIGNMENTS | GradingWorkflowSettingsTypeKeys.QUESTION_ANSWER_KEYS;

export interface WorkflowSettingsTabType {
    index: number;
    name: string;
    group: GradingWorkflowSettingsType;
    acquiresLock: boolean;
    draftType: DraftTypes;
    tabHidden?: boolean;
    tabHiddenIfMarksOnly?: boolean;
}

export interface WorkflowSettingsTabs {
    [key: string]: WorkflowSettingsTabType;
}

export interface QuestionAssignments {
    assessmentRunQuestionId: number;
    assignedEvaluatorIds: Set<number>;
    questionId: number;
}

export interface DraftAssignments {
    [key: number]: QuestionAssignments[];
}

export interface Question {
    contentItemId: number;
    contentRevisionId: number;
    title: string;
    objectType: string;
    responseDeclarations: [];
    templateDeclarations: [];
    supportedLanguages: [];
    defaultLanguage: string;
    itemBody: string;
    version: string;
    mediaInfo: [];
    maxScore: number;
    presets: {};
    questionNumberInQuestionSet: number;
    scoreByAlternativeEnabled?: boolean;
    correctResponses: {
        [key: string]: string[];
    };
}

export interface QuestionAnswerKeyCorrection {
    questionId: number;
    responseId: string;
    correctResponses: Array<string>;
}
